export default __webpack_public_path__ + "static/history-7cfb65efe3826a5d4bca5a7381883386.png";